import { typeSafeObjectKeys } from '../../util/typeSafeObjectKeys'

type TSizePalette = {
  _experimentalAnchorTableStickyHeaderZIndex: number
  _experimentalToastZIndex: number
  _experimentalNavBarZIndex: number
  _experimentalPopoverZIndex: number
  _experimentalModalZIndex: number
  _experimentalSelectMenuZIndex: number
  buttonHeight: number
  gutterWidthXs: string
  gutterWidthSm: string
  gutterWidth: string
  borderRadius: string
  cellHeightSm: string
  cellHeight: string
  cellHeightLg: string
  largeInputPadding: string
}

type TSizePaletteCssVarNames = {
  [K in keyof TSizePalette]: string
}

// NOTE(jare): the defaults for
//    _experimentalPopoverZIndex,
//    _experimentalModalZIndex,
//    _experimentalNavBarZIndex,
//    _experimentalSelectMenuZIndex
// are taken from web-app. We're keeping the same z-indices for now
// just to support legacy UI. Once we've fully migrated components
// that use these, we can rethink these values.
const SizePalette = {
  _experimentalAnchorTableStickyHeaderZIndex: 1,
  _experimentalModalZIndex: 301,
  _experimentalNavBarZIndex: 100,
  _experimentalPopoverZIndex: 1,
  _experimentalSelectMenuZIndex: 500,
  _experimentalToastZIndex: 600,
  borderRadius: '4px',
  buttonHeight: '44px',
  cellHeight: '48px',
  cellHeightLg: '60px',
  cellHeightSm: '36px',
  gutterWidth: '12px',
  gutterWidthSm: '8px',
  gutterWidthXs: '4px',
  largeInputPadding: '20px',
}

export const SizePaletteCssVarNames: TSizePaletteCssVarNames = {
  _experimentalAnchorTableStickyHeaderZIndex:
    '--rh__size-palette___experimentalAnchorTableStickyHeaderZIndex',
  _experimentalModalZIndex: '--rh__size-palette___experimentalModalZIndex',
  _experimentalNavBarZIndex: '--rh__size-palette___experimentalNavBarZIndex',
  _experimentalPopoverZIndex: '--rh__size-palette___experimentalPopoverZIndex',
  _experimentalSelectMenuZIndex:
    '--rh__size-palette___experimentalSelectMenuZIndex',
  _experimentalToastZIndex: '--rh__size-palette___experimentalToastZIndex',
  borderRadius: '--rh__size-palette__borderRadius',
  buttonHeight: '--rh__size-palette__buttonHeight',
  cellHeight: '--rh__size-palette__cellHeight',
  cellHeightLg: '--rh__size-palette__cellHeightLg',
  cellHeightSm: '--rh__size-palette__cellHeightSm',
  gutterWidth: '--rh__size-palette__gutterWidth',
  gutterWidthSm: '--rh__size-palette__gutterWidthSm',
  gutterWidthXs: '--rh__size-palette__gutterWidthXs',
  largeInputPadding: '--rh__size-palette__largeInputPadding',
}

export function getInitialSizeCssVars() {
  const variables: {
    [k: string]: string | number
  } = {}

  typeSafeObjectKeys(SizePaletteCssVarNames).forEach(key => {
    const variableName = SizePaletteCssVarNames[key]
    variables[variableName] = SizePalette[key]
  })

  return variables
}
